import { useNavigation } from 'react-router';

import { useCurrentPage } from '@jane/bloom/hooks/navigation/useCurrentPage';

export const useIsNavigatingAway = () => {
  const { location: destinationLocation, state } = useNavigation();
  const { pathname } = useCurrentPage();
  return Boolean(
    state === 'loading' && pathname !== destinationLocation?.pathname
  );
};
